(function (root) {
  'use strict';
  function price(config, baseUnit, quantity) {
    if (!config || config.enabled !== true || !Array.isArray(config.tiers)) return null;
    const tier = config.tiers.find(t => Number(t.quantity) === Number(quantity));
    if (!tier || !Number.isInteger(tier.price_cents) || tier.price_cents <= 0) return null;
    const compareCents = Math.round(Number(baseUnit) * Number(quantity));
    return { totalCents: tier.price_cents, compareCents, unitCents: Math.round(tier.price_cents / Number(quantity)), discountPercentage: 0 };
  }
  root.LMQuantityTiers = { price };
  if (typeof module !== 'undefined') module.exports = { price };
})(typeof window !== 'undefined' ? window : globalThis);
